export default "__VITE_ASSET__BFJ9dRzb__"